import React from "react";
import "./rubbingPolishing.css";
import { Link } from "react-router-dom";  
import { Helmet } from "react-helmet";  
export default function RubbingPolishing() {
  return (
    <>
    <Helmet>
      <title>Best Car Rubbing & Polishing Service in Palwal | AutoCare</title>
      <meta
        name="description"
        content="Restore your car's original shine with professional rubbing & polishing services at AutoCare in Palwal. We offer premium car repair & detailing solutions for all car brands."
      />
      <link
        rel="canonical"
        href="https://car-repair-mechanic-palwal.netlify.app/services/rubbing-polishing"
      />
    </Helmet>
    <section className="servicePage">
      <div className="serviceContent">

        {/* TEXT SECTION */}
        <div className="textContent">
          <h1>Best Car Rubbing & Polishing Service in Palwal</h1>

          <p>
            Restore your car’s original shine with
            <strong> professional rubbing & polishing services</strong> at
            <span className="highlight"> AutoCare</span>.
            We are a trusted <span className="highlight">Auto Care in Palwal</span>
            offering premium <strong>car repair & detailing solutions</strong>
            for all car brands.
          </p>

          <h2>What is Car Rubbing & Polishing?</h2>
          <p>
            Car rubbing removes light scratches, swirl marks, oxidation,
            and dull paint layers, while polishing enhances gloss and smoothness.
            It’s one of the most effective ways to improve your car’s appearance
            without repainting.
          </p>

          <h2>Benefits of Rubbing & Polishing</h2>
          <ul>
            <li>Removes light scratches & swirl marks</li>
            <li>Restores glossy showroom finish</li>
            <li>Enhances paint smoothness</li>
            <li>Improves overall car appearance</li>
            <li>Protects paint from aging & oxidation</li>
          </ul>

          <h2>Why Choose AutoCare for Rubbing & Polishing?</h2>
          <ul>
            <li>One of the <span className="highlight">best car polishing shops in Palwal</span></li>
            <li>Experienced technicians & premium compounds</li>
            <li>Safe process for all paint types</li>
            <li>Affordable pricing & quick service</li>
            <li>Trusted <span className="highlight">Auto Care in Palwal</span> for car repair</li>
          </ul>

          <h2>Book Rubbing & Polishing Near You</h2>
          <p>
            Searching for the <span className="highlight">best car rubbing & polishing near me</span>?
            Choose <strong>AutoCare</strong> for professional results,
            long-lasting shine, and reliable car care.
          </p>

          <button className="primaryBtn">
            <Link to="/contact">
            Book Rubbing & Polishing
            </Link>
          </button>
        </div>

        {/* IMAGE SECTION */}
        <div className="imageContent">
          <img
            src="/carServiceImages/rubbingPolishing.webp"
            alt="Best Car Rubbing and Polishing Service in Palwal"
          />
        </div>

      </div>
    </section>
    </>
  );
}
